<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row  class="m-0 mb-1 elevation-1" style="max-height: 2.55rem">
        <v-col class="p-0">
          <v-row class="m-0" style="height: 2.55rem">
        <span style="margin-top: auto;
                     margin-bottom: auto; margin-left: 12px;" class="text-h5">Lohnarten</span>
            <v-btn
                v-if="isDetail"
                icon
                color="blue"
                style="margin-top: auto; margin-bottom: auto; margin-left: 24px"
                :disabled="this.currentItemIndex === 0"
                @click="moveSelection('left', true)"
            >
              <v-icon>mdi-page-first</v-icon>
            </v-btn>
            <v-btn
                v-if="isDetail"
                icon
                color="blue"
                style="margin-top: auto; margin-bottom: auto;"
                :disabled="this.currentItemIndex === 0"
                @click="moveSelection('left', false)"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
                v-if="isDetail"
                icon
                color="blue"
                style="margin-top: auto; margin-bottom: auto;"
                :disabled="this.currentItemIndex === this.tableData.length - 1"
                @click="moveSelection('right', false)"

            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn
                v-if="isDetail"
                icon
                color="blue"
                style="margin-top: auto; margin-bottom: auto;"
                :disabled="this.currentItemIndex === this.tableData.length - 1"
                @click="moveSelection('right', true)"
            >
              <v-icon>mdi-page-last</v-icon>
            </v-btn>
            <v-btn
                v-if="isAdmin && tabs[currentTab].value === 'ALL' && tableData.length === 0"
                block
                color="warning"
                class="t-btn-long ml-2"
                @click="toggleSetupMode"
            >
              <v-icon left>
                mdi-pencil
              </v-icon>
              {{modeSetup ? 'Normalmodus' :'Einrichtungsmodus'}}
            </v-btn>
            <v-btn
                v-if="modeSetup"
                block
                color="success"
                class="t-btn-long ml-2"
                @click="$refs.parseFileDialog.show()"
            >
              <v-icon left>
                mdi-microsoft-excel
              </v-icon>
              Importieren
            </v-btn>
            <div class="t-btn-left"></div>
            <v-btn
                block
                color="success"
                class="white--text t-btn"
                :disabled="this.isEdit"
                @click="toggleDetails"
            >
              <v-icon left>
                {{isDetail ? 'mdi-view-list' : 'mdi-eye-outline'}}
              </v-icon>
              {{isDetail ? 'Liste' : 'Details'}}
            </v-btn>
            <v-btn
                v-if="(!isEdit || !singleEdit) && modeSetup"
                block
                color="error"
                class="t-btn"
                :disabled="!hasSelects"
                @click="onDelete"
            >
              <v-icon left>
                mdi-delete
              </v-icon>
              Löschen
            </v-btn>
            <v-btn
                v-if="!isEdit || !singleEdit"
                class="white--text t-btn"
                color="primary"
                block
                @click="addRow"
            >
              <v-icon left>
                mdi-plus-circle-outline
              </v-icon>
              Anlegen
            </v-btn>
            <v-btn
                v-if="isEdit && !modeSetup"
                block
                color="warning"
                class="t-btn"
                @click="resetEdit"
            >
              <v-icon left>
                mdi-close-circle-outline
              </v-icon>
              Abbrechen
            </v-btn>
            <v-btn
                v-if="isEdit || !singleEdit"
                block
                color="success"
                class="white--text t-btn"
                :disabled="!isEdit || tableData.length === 0"
                @click="onSave"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Speichern
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="m-0" style="flex: 0 0 auto;" v-if="!isDetail">
        <v-col class="p-0 custom-col-6">
          <v-tabs v-model="currentTab">
            <v-tab
                v-for="item in tabs"
                :key="item.value"
                :disabled="isEdit"
            >
              {{ item.name }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>
      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col class="p-0">
          <spread-sheet :key="modeSetup ? 'setup' + currentTab : 'normal' + currentTab" v-if="!isDetail" ref="spreadsheet" id="spreadsheet"
                        :collumns="collumns"
                        :data="tableData"
                        :temp-col-width="50"
                        :is-single-edit="singleEdit"
                        @change="dataChanged"
                        @selection-change="selectionChange"
                        @dbl-click="dblClick"
                        style="margin-top: 0px"/>
          <lohn-detail v-else ref="detail" id="detail"
                       :item="currentItem"
                       :employment-types="employment_types"
                       :augrs="augrs"
                       @change="dataChanged"/>
        </v-col>
      </v-row>

      <v-dialog
          ref="timePicker"
          v-model="showTimePicker"
          persistent
          width="290px"
      >
        <v-time-picker
            v-model="timepickerValue"
            v-if="showTimePicker"
            full-width
            format="24hr"
        >
          <v-spacer></v-spacer>
          <v-btn
              text
              color="primary"
              @click="timepickerValue = timepickerValueSave; $refs.spreadsheet.spreadsheet.closeEditor(timePickerCell, true); showTimePicker = false;"
          >
            Abbrechen
          </v-btn>
          <v-btn
              text
              color="primary"
              @click="$refs.spreadsheet.spreadsheet.closeEditor(timePickerCell, true); showTimePicker = false;"
          >
            OK
          </v-btn>
        </v-time-picker>
      </v-dialog>
    </div>
    <v-snackbar
        v-model="showErrorMessage"
        :timeout="5000"
        right
        color="red accent-2"
    >
      <b>{{ errorMessage }}</b>

      <template v-slot:action="{ attrs }">
        <v-btn
            icon
            color="white"
            v-bind="attrs"
            @click="showErrorMessage = false"
        >
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <parse-file-dialog ref="parseFileDialog"
                       :cols="collumns"
                       :pre-defined-data="$options.importOrder"
                       :empty-item="$options.emptyLohn"
                       :transform-item="$options.transformLohn"
                       @import="onImport"
    />
  </v-main>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import {DateTime as LuxonDateTime} from "luxon";
import SpreadSheet from "@/views/basis_data/common/SpreadSheet.vue";
import LohnDetail from "@/views/basis_data/lohn_detail.vue";
import ParseFileDialog from "@/views/basis_data/dialogs/ParseFileDialog.vue";

import {v4} from "uuid";
import {decryptData, encryptData} from "@/shared/crypto";
import Json from "vue-resource/src/http/interceptor/json";



export default {
  name: "lohn_list",
  components: {
    SpreadSheet,
    LohnDetail,
    ParseFileDialog
  },
  importOrder: ['access', 'name', 'lohn_usage_type'],
  emptyLohn: {
    id: '',
    bis_id: 'Neuanlage',
    kloon_id: 0,
    name: '',
    access: '',
    lohn_type: '',
    blocked: false,
    wage_type_number: '',
    unit: '',
    export_payroll: false,
    evaluate: false,
    lohn_usage_type: '',
    employment_type: '',
    automatic_time_surcharge: false,
    time_dependant: false,
    time_1_start: '',
    time_1_end: '',
    time_2_start: '',
    time_2_end: '',
    weekday_dependant: false,
    weekdays: '',
    special_rules: false,
    before_holiday: false,
    on_holiday: '0',
    after_holiday: false,
    time_comparison: '0',
    book_till: '',
    book_on_holidays: false,
    surcharge_bill: '0',
    surcharge_bill_extern: '0',
    surcharge_salary: '0',
    calculation_type: '+',
    only_augr: '',
    dont_send_mobile: false,
    only_rb: false,
    for_dates: 'N',
    dates: '',
    working_hours: '',
  },
  transformLohn: (lohn) => {
    lohn.id = v4();
    if (lohn.lohn_usage_type === undefined) {
      lohn.lohn_usage_type = '';
    }
    lohn.lohn_usage_type = lohn.lohn_usage_type.trim();
    if (lohn.lohn_usage_type === 'Std.' || lohn.lohn_usage_type === 'Std' || lohn.lohn_usage_type === 'Stunde') {
      lohn.unit = '1';
      lohn.lohn_usage_type = '1PE02';
    } else {
      lohn.unit = '2';
      lohn.lohn_usage_type = '2PE05';
    }
    if (lohn.access === undefined) {
      lohn.access = '';
    }
    lohn.access = ''+lohn.access;
    return lohn;
  },
  data () {
    return {
      currentTab: 0,
      tabs: [{name: 'Alle', value: 'ALL'}, {name: 'Erschwerniszuschlag', value: 'E'}, {name: 'Fehlzeit', value: 'F'}, {name: 'Mehrarbeitszeit', value: 'M'}, {name: 'Rufbereitschaft', value: 'R'}, {name: 'Vortragsbuchung', value: 'V'}, {name: 'Zuschlag Lohnabrechnung', value: 'Z'}, {name: 'Zuschlag Zeitkonto', value: 'ZZ'}],
      cols: {
        "ALL": [
          {type: 'readonly', title: 'Laufende Nummer', name: 'bis_id', width: '130', readOnly: true},
          {type: 'text', title: 'Lohnart', name: 'name', width: '250', required: true, max_length: '50'},
            {type: 'text', title: 'Nr. der Lohnart', name: 'access', width: '140', required: true, max_length: '50'},
            {type: 'dropdown', title: 'Typ', name: 'lohn_type', width: '200', required: true, max_length: '50', source: [
                {id: "V", name: "Vortragsbuchung"}, {id: "R", name: "Rufbereitschaft"}, {id: "M", name: "Mehrarbeitszeit"}, {id: "F", name: "Fehlzeit"}, {id: "Z", name: "Zuschlag Lohnabrechnung"}, {id: "ZZ", name: "Zuschlag Zeitkonto"}, {id: "E", name: "Erschwerniszuschlag"}
              ], readonly: true},
            // watch out, we have to combine unit with lohn_usage_type to get the correct names here
          {type: 'dropdown', title: 'Belegart', name: 'lohn_usage_type', width: '230', required: true, max_length: '50', source: [
              {id: "1PE02", name: "Abbuchung Stunden (PE02)"}, {id: "2PE05", name: "Abbuchung Tage (PE05)"}, {id: "1PE06", name: "Zubuchung Stunden (PE06)"}, {id: "2PE07", name: "Zubuchung Tage (PE07)"}, {id: "3PE02", name: "Pauschale/Stunde"}, {id: "3PE05", name: "Pauschale/Tag"}]},
          {type: 'checkbox', title: 'Gesperrt', name: 'blocked', width: '80', align: 'center'},
          {type: 'calendar', title: 'Buchbar bis', name: 'book_till', options: { format:'DD.MM.YYYY' }, width: '120'},
          {type: 'text', title: 'Bez. Lohnart Export', name: 'wage_type_number', width: '160', max_length: '50'},
          {type: 'dropdown', title: 'Beschäftigungsverhältnis', name: 'employment_type', width: '200', max_length: '80', source: []},
        ],
        "V": [
          {type: 'checkbox', title: 'An Feiertagen buchen', name: 'book_on_holidays', width: '200', max_length: '80', align: 'center'},
        ],
        "R": [
          {type: 'checkbox', title: 'An Feiertagen buchen', name: 'book_on_holidays', width: '200', max_length: '80', align: 'center'},
          {type: 'numeric', title: 'Zuschlag Rechnung', mask:'#.## %', name: 'surcharge_bill', width: '200', max_length: '80'},
          {type: 'numeric', title: 'Zuschlag Rechnung extern', mask:'#.## %', name: 'surcharge_bill_extern', width: '200', max_length: '80'},
          {type: 'numeric', title: 'Zuschlag Lohn',  mask:'#.## %', name: 'surcharge_salary', width: '200', max_length: '80'},
          {type: 'dropdown', title: 'Berechnen mit', name: 'calculation_type', width: '200', max_length: '80', source: [
              {id: "+", name: "+ [z.B. 1:00 + 50% = 1:30]"}, {id: "*", name: "* [z.B. 1:00 * 50% = 0:30]"},{id: "e", name: "in Euro"},]},
        ],
        "M": [
          {type: 'checkbox', title: 'An Feiertagen buchen', name: 'book_on_holidays', width: '200', max_length: '80', align: 'center'},
          {type: 'numeric', title: 'Zuschlag Rechnung', mask:'#.## %', name: 'surcharge_bill', width: '200', max_length: '80'},
          {type: 'numeric', title: 'Zuschlag Rechnung extern', mask:'#.## %', name: 'surcharge_bill_extern', width: '200', max_length: '80'},
          {type: 'numeric', title: 'Zuschlag Lohn',  mask:'#.## %', name: 'surcharge_salary', width: '200', max_length: '80'},
          {type: 'dropdown', title: 'Berechnen mit', name: 'calculation_type', width: '200', max_length: '80', source: [
              {id: "+", name: "+ [z.B. 1:00 + 50% = 1:30]"}, {id: "*", name: "* [z.B. 1:00 * 50% = 0:30]"},{id: "e", name: "in Euro"},]},
        ],
        "F": [
          {type: 'checkbox', title: 'An Feiertagen buchen', name: 'book_on_holidays', width: '200', max_length: '80', align: 'center'},
          {type: 'checkbox', title: 'nicht an mobile Geräte senden', name: 'dont_send_mobile', width: '200', max_length: '80', align: 'center'},
        ],
        "Z": [
          {type: 'checkbox', title: 'Auto. Zuschlag', name: 'automatic_time_surcharge', width: '200', max_length: '80', align: 'center'},
          {type: 'checkbox', title: 'An Feiertagen buchen', name: 'book_on_holidays', width: '200', max_length: '80', align: 'center'},
          {type: 'numeric', title: 'Zuschlag Rechnung', mask:'#.## %', name: 'surcharge_bill', width: '200', max_length: '80'},
          {type: 'numeric', title: 'Zuschlag Rechnung extern', mask:'#.## %', name: 'surcharge_bill_extern', width: '200', max_length: '80'},
          {type: 'numeric', title: 'Zuschlag Lohn',  mask:'#.## %', name: 'surcharge_salary', width: '200', max_length: '80'},
          {type: 'dropdown', title: 'Berechnen mit', name: 'calculation_type', width: '200', max_length: '80', source: [
              {id: "+", name: "+ [z.B. 1:00 + 50% = 1:30]"}, {id: "*", name: "* [z.B. 1:00 * 50% = 0:30]"},{id: "e", name: "in Euro"},]},
          {type: 'checkbox', title: 'nach Uhrzeit', name: 'time_dependant', width: '160', max_length: '80', align: 'center'},
          {type: 'text', title: 'Zeit von', name: 'time_1_start', width: '200', max_length: '5', editor: null},
          {type: 'text', title: 'Zeit bis', name: 'time_1_end', width: '200', max_length: '5', editor: null},
          {type: 'text', title: 'Zeit von', name: 'time_2_start', width: '200', max_length: '5', editor: null},
          {type: 'text', title: 'Zeit bis', name: 'time_2_end', width: '200', max_length: '5', editor: null},
          {type: 'checkbox', title: 'nach Wochentag', name: 'weekday_dependant', width: '160', max_length: '80', align: 'center'},
          {type: 'text', title: 'Wochentage', name: 'weekdays', width: '200', max_length: '80'},
          {type: 'checkbox', title: 'Sonderregeln', name: 'special_rules', width: '160', max_length: '80', align: 'center'},
          {type: 'checkbox', title: 'vor Feiertag', name: 'before_holiday', width: '160', max_length: '80', align: 'center'},
          {type: 'dropdown', title: 'am Feiertag', name: 'on_holiday', width: '160', max_length: '80',source: [
              {id: "0", name: "nicht gesetzt"}, {id: "1", name: "am Feiertag"},{id: "~", name: "nicht am Feiertag"},]},
          {type: 'checkbox', title: 'nach Feiertag', name: 'after_holiday', width: '160', max_length: '80', align: 'center'},
          {type: 'dropdown', title: 'Nach Auftragsgruppe', name: 'only_augr', width: '200', max_length: '80', source: []},
          {type: 'dropdown', title: 'nach Datum', name: 'for_dates', width: '160', max_length: '80',source: [
              {id: "0", name: "Nein"}, {id: "1", name: "jeweils am"},{id: "~", name: "nicht am"},]},
          {type: 'text', title: 'Daten', name: 'dates', width: '200', max_length: '80'},
          {type: 'dropdown', title: 'nach Arbeitszeit', name: 'working_hours', width: '160', max_length: '80',source: [
              {id: "", name: "nicht gesetzt"}, {id: "in", name: "innerhalb Arbeitszeit"},{id: "out", name: "außerhalb Arebitszeit"},]},
          {type: 'dropdown', title: 'Nach Auftragsgruppe', name: 'only_augr', width: '200', max_length: '80', source: []},
          {type: 'checkbox', title: 'bei Rufbereitschaft', name: 'only_rb', width: '160', max_length: '80', align: 'center'},
        ],
        "ZZ": [
          {type: 'checkbox', title: 'Auto. Zuschlag', name: 'automatic_time_surcharge', width: '200', max_length: '80', align: 'center'},
          {type: 'checkbox', title: 'An Feiertagen buchen', name: 'book_on_holidays', width: '200', max_length: '80', align: 'center'},
          {type: 'numeric', title: 'Zuschlag Rechnung', mask:'#.## %', name: 'surcharge_bill', width: '200', max_length: '80'},
          {type: 'numeric', title: 'Zuschlag Rechnung extern', mask:'#.## %', name: 'surcharge_bill_extern', width: '200', max_length: '80'},
          {type: 'numeric', title: 'Zuschlag Lohn',  mask:'#.## %', name: 'surcharge_salary', width: '200', max_length: '80'},
          {type: 'dropdown', title: 'Berechnen mit', name: 'calculation_type', width: '200', max_length: '80', source: [
              {id: "+", name: "+ [z.B. 1:00 + 50% = 1:30]"}, {id: "*", name: "* [z.B. 1:00 * 50% = 0:30]"},{id: "e", name: "in Euro"},]},
          {type: 'checkbox', title: 'nach Uhrzeit', name: 'time_dependant', width: '160', max_length: '80', align: 'center'},
          {type: 'text', title: 'Zeit von', name: 'time_1_start', width: '200', max_length: '5', editor: null},
          {type: 'text', title: 'Zeit bis', name: 'time_1_end', width: '200', max_length: '5', editor: null},
          {type: 'text', title: 'Zeit von', name: 'time_2_start', width: '200', max_length: '5', editor: null},
          {type: 'text', title: 'Zeit bis', name: 'time_2_end', width: '200', max_length: '5', editor: null},
          {type: 'checkbox', title: 'nach Wochentag', name: 'weekday_dependant', width: '160', max_length: '80', align: 'center'},
          {type: 'text', title: 'Wochentage', name: 'weekdays', width: '200', max_length: '80'},
          {type: 'checkbox', title: 'Sonderregeln', name: 'special_rules', width: '160', max_length: '80', align: 'center'},
          {type: 'checkbox', title: 'vor Feiertag', name: 'before_holiday', width: '160', max_length: '80', align: 'center'},
          {type: 'dropdown', title: 'am Feiertag', name: 'on_holiday', width: '160', max_length: '80',source: [
              {id: "0", name: "nicht gesetzt"}, {id: "1", name: "am Feiertag"},{id: "~", name: "nicht am Feiertag"},]},
          {type: 'checkbox', title: 'nach Feiertag', name: 'after_holiday', width: '160', max_length: '80', align: 'center'},
          {type: 'dropdown', title: 'Nach Auftragsgruppe', name: 'only_augr', width: '200', max_length: '80', source: []},
          {type: 'dropdown', title: 'nach Datum', name: 'for_dates', width: '160', max_length: '80',source: [
              {id: "0", name: "Nein"}, {id: "1", name: "jeweils am"},{id: "~", name: "nicht am"},]},
          {type: 'text', title: 'Daten', name: 'dates', width: '200', max_length: '80'},
          {type: 'dropdown', title: 'nach Arbeitszeit', name: 'working_hours', width: '160', max_length: '80',source: [
              {id: "", name: "nicht gesetzt"}, {id: "in", name: "innerhalb Arbeitszeit"},{id: "out", name: "außerhalb Arebitszeit"},]},
          {type: 'dropdown', title: 'Nach Auftragsgruppe', name: 'only_augr', width: '200', max_length: '80', source: []},
          {type: 'checkbox', title: 'bei Rufbereitschaft', name: 'only_rb', width: '160', max_length: '80', align: 'center'},
        ],
        "E": [
            {type: 'checkbox', title: 'An Feiertagen buchen', name: 'book_on_holidays', width: '200', max_length: '80', align: 'center'},
            {type: 'numeric', title: 'Zuschlag Rechnung', mask:'#.## %', name: 'surcharge_bill', width: '200', max_length: '80'},
            {type: 'numeric', title: 'Zuschlag Rechnung extern', mask:'#.## %', name: 'surcharge_bill_extern', width: '200', max_length: '80'},
            {type: 'numeric', title: 'Zuschlag Lohn',  mask:'#.## %', name: 'surcharge_salary', width: '200', max_length: '80'},
            {type: 'dropdown', title: 'Berechnen mit', name: 'calculation_type', width: '200', max_length: '80', source: [
                {id: "+", name: "+ [z.B. 1:00 + 50% = 1:30]"}, {id: "*", name: "* [z.B. 1:00 * 50% = 0:30]"},{id: "e", name: "in Euro"},]},
          {type: 'dropdown', title: 'Nach Auftragsgruppe', name: 'only_augr', width: '200', max_length: '80', source: []},
          {type: 'checkbox', title: 'Auto-Zuschlag, nicht an mobile Geräte', name: 'dont_send_mobile', width: '200', max_length: '80', align: 'center'},
        ],
        "ADDITIONS": [{type: 'checkbox', title: 'Auswerten ?', name: 'evaluate', width: '90', align: 'center'},],
      },
      lohns: {},
      loader: undefined,
      singleEdit: true,
      hasSelects: false,
      isEdit: false,
      editId: '',
      loadedOnce: false,
      augrs: [],
      employment_types: [],
      timePickerCell: null,
      showTimePicker: false,
      timepickerValue: '',
      timepickerValueSave: '',
      currentSelection: [],
      isDetail: false,
      itemId: null,
      currentItem: null,
      currentItemIndex: null,
      errorMessage: '',
      showErrorMessage: false,
      isAdmin: false,
      modeSetup: false,
    }
  },
  mounted () {
  },
  created() {
    this.isAdmin = this.$cookies.get("ps_username") === 'admin';
    this.singleEdit = !this.isAdmin;
    // create custom Editor
    let timePicker = {
      closeEditor : (cell, save) => {
        var value = this.timepickerValue;
        cell.innerHTML = value;
        return value;
      },
      openEditor : (cell) => {
        this.timepickerValue = cell.innerHTML;
        this.timepickerValueSave = cell.innerHTML;
        this.timePickerCell = cell;
        // Update cell
        cell.classList.add('editor');
        cell.innerHTML = '';
        this.showTimePicker = true;
      },
      getValue : (cell) => {
        return cell.innerHTML;
      },
      setValue : (cell, value) => {
        cell.innerHTML = value;
      }
    }
    this.cols['Z'][7].editor = timePicker;
    this.cols['Z'][8].editor = timePicker;
    this.cols['Z'][9].editor = timePicker;
    this.cols['Z'][10].editor = timePicker;

    this.cols['ZZ'][7].editor = timePicker;
    this.cols['ZZ'][8].editor = timePicker;
    this.cols['ZZ'][9].editor = timePicker;
    this.cols['ZZ'][10].editor = timePicker;
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/basis_data/lohn'
    ).then(this.responseOkGet, this.responseError)
  },
  watch: {
    currentTab: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal && this.loadedOnce) {
          this.$nextTick(() => {
            this.$refs.spreadsheet.mountSpreadsheet();
          });
        }
      },
      deep: false
    },
  },
  computed: {
      collumns() {
        if (this.tabs[this.currentTab].value === 'ALL') {
          return [...this.cols['ALL'], ...this.cols['ADDITIONS']]
        } else {
          return [...this.cols['ALL'], ...this.cols[this.tabs[this.currentTab].value], ...this.cols['ADDITIONS']];
        }
      },
        tableData() {
          if (this.tabs[this.currentTab].value === 'ALL') {
            let all = [];
            for (const property in this.lohns) {
              all = [...all, ...this.lohns[property]];
            }
            all.sort((a, b) => {
              return a.bis_id.localeCompare(b.bis_id);
            });
            return all;
          } else {
            return [...this.lohns[this.tabs[this.currentTab].value]];
        }
      }
  },
  methods: {
    onImport(daten) {
      if (daten.length === 0) {
        return;
      }
      this.isEdit = true;
      //this.lohns['ALL'] = daten;
      this.$set(this.lohns, "ALL", daten);
      this.$nextTick(() => {
        console.log(this.tableData)
        this.$refs.spreadsheet.reload();
      });
    },
    onDelete() {
      if (this.modeSetup) {
        this.$refs.spreadsheet.deleteRows(this.currentSelection[0], this.currentSelection.length);
        this.currentSelection = [];
        this.hasSelects = false;
      }
    },
    toggleSetupMode() {
      this.modeSetup = !this.modeSetup;
      this.cols['ALL'][8].type = this.modeSetup ? 'text' : 'dropdown';

      this.$nextTick(() => {
        this.$refs.spreadsheet.mountSpreadsheet();
      });
    },
    onSave() {
      let data = [];
      if (this.isDetail) {
        data = [this.$refs.detail.getData()];
      } else {
        if (this.singleEdit) {
          data = this.$refs.spreadsheet.getData(this.editId);
          data = [data];
          // attach the non-visible properties back to the data
          for (let i = 0; i < data.length; i++) {
            if (data[i].bis_id === 'Neuanlage') {
              continue;
            }
            let found = false;
            for (const property in this.lohns) {
              for (let j = 0; j < this.lohns[property].length; j++) {
                if (this.lohns[property][j].id === data[i].id) {
                  let d = {...this.lohns[property][j]};
                  for (const newProp in data[i]) {
                    d[newProp] = data[i][newProp];
                  }
                  data[i] = d;
                  found = true;
                  break;
                }
              }
              if (found) {
                break;
              }
            }
          }
        } else {
          // multi edit
          let all = [];
          for (const property in this.lohns) {
            all = [...all, ...this.lohns[property]];
          }
          all = JSON.parse(JSON.stringify(all));
          data = this.$refs.spreadsheet.getAllData();
          for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < all.length; j++) {
              if (data[i].id === all[j].id) {
                for (const newProp in data[i]) {
                  all[j][newProp] = data[i][newProp];
                }
                break;
              }
            }
          }
          data = all;
        }
      }
      // fix the data
      for (let i = 0; i < data.length; i++) {
        data[i].kloon_id =  data[i].kloon_id === '' || !data[i].kloon_id ? 0 : data[i].kloon_id;
        if (data[i].book_till !== '') {
          data[i].book_till = data[i].book_till.split(" ")[0].split("-").join("");
        } else {
          data[i].book_till = '99999999';
        }
        data[i].blocked = data[i].blocked ? '1' : '0';
        data[i].evaluate = data[i].evaluate ? '1' : '0';
        if (data[i].lohn_usage_type !== undefined && data[i].lohn_usage_type !== '') {
          data[i].unit = data[i].lohn_usage_type.slice(0, 1);
          data[i].lohn_usage_type = data[i].lohn_usage_type.slice(-4);
        } else {
          data[i].lohn_usage_type = '';
        }
        if (data[i].lohn_type === 'Z' || data[i].lohn_type === 'E' || data[i].lohn_type === 'R') {
          data[i].export_payroll = '1';
        } else {
          data[i].export_payroll = '0';
        }
        if (data[i].lohn_type === 'F') {
          data[i].time_comparison = '1';
        }
        data[i].dont_send_mobile = data[i].dont_send_mobile ? '1' : '0';
        data[i].automatic_time_surcharge = data[i].automatic_time_surcharge ? '1' : '0';
        data[i].weekday_dependant = data[i].weekday_dependant ? '1' : '0';
        data[i].special_rules = data[i].special_rules ? '1' : '0';
        data[i].before_holiday = data[i].before_holiday ? '1' : '0';
        data[i].after_holiday = data[i].after_holiday ? '1' : '0';
        data[i].book_on_holidays = data[i].book_on_holidays ? '1' : '0';
        data[i].time_dependant = data[i].time_dependant ? '1' : '0';
        data[i].only_rb = data[i].only_rb ? '1' : '0';
        if (!data[i].for_dates) {
          data[i].for_dates = '0';
        }
        if (!data[i].on_holiday) {
          data[i].on_holiday = '0';
        }
        if (!data[i].name) {
          data[i].name = '';
        }
        data[i].name = data[i].name.trim();
      }
      this.errorMessage = this.validate(data);
      if (this.errorMessage) {
        this.showErrorMessage = true;
        return;
      }
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/basis_data/lohn?is_single=' + (this.singleEdit || this.isDetail ? 'true' : 'false'), data
      ).then(this.responseOkPost, this.responseError)
    },
    validate(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].name.trim() === "") {
          return "Der Name muss gesetzt sein."
        }
        if (data[i].access.trim() === "") {
          return "Die Nummer der Lohnart muss gesetzt sein."
        }
        if (data[i].lohn_type === "") {
          return "Der Typ der Lohnart muss gesetzt sein."
        }
        if (data[i].lohn_usage_type === "") {
          return "Die Belegart der Lohnart muss gesetzt sein."
        }
        for (const property in this.lohns) {
          for (let j = 0; j < this.lohns[property].length; j++) {
            if (this.lohns[property][j].name === data[i].name && this.lohns[property][j].id !== data[i].id) {
              return "Der Name muss eindeutig sein."
            } else if (this.lohns[property][j].access === data[i].access && this.lohns[property][j].id !== data[i].id) {
              return "Die Nummer der Lohnart muss eindeutig sein."
            }
          }
        }
      }
      return "";
    },
    moveSelection(direction, gotToMax) {
      if (this.isDetail) {
        if (gotToMax) {
          this.currentItemIndex = direction === 'left' ? 0 : this.tableData.length - 1;
        } else {
          this.currentItemIndex = direction === 'left' ? this.currentItemIndex - 1 : this.currentItemIndex + 1;
        }
        this.currentItem = this.tableData[this.currentItemIndex];
      }
    },
    toggleDetails() {
      if (!this.isDetail) {
        this.currentItem = this.itemId ? this.tableData.find(item => item.id === this.itemId) : this.tableData[0];
        this.currentItemIndex = this.tableData.findIndex(item => item.id === this.currentItem.id);
      } else {
        this.hasSelects = false;
        this.currentSelection = [];
        this.itemId = '';
      }

      this.isDetail = !this.isDetail;
      if (this.isDetail) {
        //this.$refs.detail.$emit('change', false);
      } else {
        this.$nextTick(() => {
          this.$refs.spreadsheet.mountSpreadsheet();
        });
      }
    },

    getLohnCollumns(lohnType) {
      return [...this.cols['ALL'], ...this.cols[lohnType]];
    },
    selectionChange(hasSelection, selection) {
      this.hasSelects = hasSelection;
      this.currentSelection = selection;
      if ((!this.singleEdit || !this.isEdit)) {
        if (hasSelection) {
          this.itemId = this.tableData[selection[0]].id;
        } else {
          this.itemId = '';
        }
      }
    },
    dblClick(index) {
      if (!this.isEdit) {
        this.itemId = this.tableData[index].id;
        this.toggleDetails();
      }
    },
    resetEdit() {
      let deleteIndex = -1;
      let deleteProp = '';
      for (const property in this.lohns) {
        for (let i = 0; i < this.lohns[property].length; i++) {
          if (this.lohns[property][i].id === this.editId && this.lohns[property][i].bis_id === 'Neuanlage') {
            deleteIndex = i;
            deleteProp = property;
            break
          }
        }
        if (deleteIndex !== -1) {
          break;
        }
      }
      if (deleteIndex !== -1) {
        this.lohns[deleteProp].splice(deleteIndex, 1);
      }
      if (!this.isDetail) {
        if (!this.singleEdit) {
          this.$nextTick(() => {
            this.$refs.spreadsheet.reload();
          });
        } else {
          let editId = this.editId;
          this.$nextTick(() => {
            this.$refs.spreadsheet.resetEdit(editId);
          });
        }
      } else {
        if (this.currentItem.bis_id !== 'Neuanlage') {
          this.$refs.detail.resetEdit();
        } else {
          this.moveSelection('left', true)
        }
      }
      this.editId = '';
      this.isEdit = false;
    },
    addRow() {
      if (!this.isDetail) {
        this.toggleDetails();
      }
      let d ={
        id: v4(),
        bis_id: 'Neuanlage',
        kloon_id: 0,
        name: '',
        lohn_type: this.tabs[this.currentTab].value === 'ALL' ? '' : this.tabs[this.currentTab].value,
        blocked: false,
        wage_type_number: '',
        unit: '',
        export_payroll: false,
        evaluate: false,
        lohn_usage_type: '',
        employment_type: '',
        automatic_time_surcharge: this.tabs[this.currentTab].value === 'Z' || this.tabs[this.currentTab].value === 'ZZ',
        time_dependant: false,
        time_1_start: '',
        time_1_end: '',
        time_2_start: '',
        time_2_end: '',
        weekday_dependant: false,
        weekdays: '',
        special_rules: false,
        before_holiday: false,
        on_holiday: '0',
        after_holiday: false,
        time_comparison: '0',
        book_till: '',
        book_on_holidays: false,
        surcharge_bill: '0',
        surcharge_bill_extern: '0',
        surcharge_salary: '0',
        calculation_type: '+',
        only_augr: '',
        dont_send_mobile: false,
        only_rb: false,
        for_dates: 'N',
        dates: '',
        working_hours: '',
      };
      if (this.tabs[this.currentTab].value === 'ALL') {
        if (this.lohns['ALL'] === undefined) {
          this.$set(this.lohns, "ALL", []);
        }
        this.lohns['ALL'].push(d);
      } else {
        this.lohns[this.tabs[this.currentTab].value].push(d);
      }
      if(this.isDetail) {
        this.currentItem = d;
        this.currentItemIndex = this.tableData.length - 1;
        this.editId = d.id;
        this.isEdit = true;
      } else {
        this.$refs.spreadsheet.addRow(d);
      }
    },
    dataChanged(id) {
      this.editId = id;
      if (!this.isDetail) {
        this.itemId = '';
      }
      this.isEdit = true;
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.lohns = this.processLohns(response.body.lohn_map);
        this.augrs = response.body.augrs;
        this.employment_types = response.body.employment_types;
        for (let i = 0; i < this.augrs.length; i++) {
          this.cols['E'][5].source.push({id: this.augrs[i].gischl, name: this.augrs[i].name});
          this.cols['Z'][21].source.push({id: this.augrs[i].gischl, name: this.augrs[i].name});
          this.cols['ZZ'][21].source.push({id: this.augrs[i].gischl, name: this.augrs[i].name});
        }
        this.cols['ALL'][8].source  = this.employment_types;
        this.$nextTick(() => {
          this.$refs.spreadsheet.mountSpreadsheet();
          this.loadedOnce = true;
        });
      } else {
        window.location = Redirect_500;
      }
    },
    async responseOkPost(response) {
      this.hideLoader();
      if (response.status === 200) {
        let items = (await this.processLohns(response.body));
        if (this.singleEdit || this.isDetail) {
          let item = items['RES'][0];
          console.log(item)
          let foundInProp = '';
          for (const property in this.lohns) {
            for (let i = 0; i < this.lohns[property].length; i++) {
              if (this.lohns[property][i].id === item.id) {
                if(this.lohns[property][i].lohn_type !== item.lohn_type) {
                  foundInProp = property;
                  this.lohns[property].splice(i, 1);
                  this.lohns[item.lohn_type].push(item);
                } else {
                  this.lohns[property][i] = item;
                }
                break;
              }
            }
          }
          if (this.isDetail) {
            this.currentItem = item;
          } else {
            this.$nextTick(() => {
              if (foundInProp === '' || this.tabs[this.currentTab].value === "ALL") {
                this.$refs.spreadsheet.updateRow(item);
                this.editId = '';
                this.isEdit = false;
              } else {
                this.$refs.spreadsheet.resetEdit(item.id);
              }
            });
          }
          this.editId = '';
          this.isEdit = false;
        } else if (this.modeSetup) {
          window.location.reload();
        } else  {
          this.lohns = items;
          this.$nextTick(() => {
            this.$refs.spreadsheet.reload();
          });
          this.editId = '';
          this.isEdit = false;
        }
      } else {
        window.location = Redirect_500;
      }
    },

    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    processLohns(lohns) {
      for (const property in lohns) {
        for (let i = 0; i < lohns[property].length; i++) {
          if (lohns[property][i].book_till === '99999999') {
            lohns[property][i].book_till = '';
          } else {
            // has weird formate 20240630 bring it to 30.06.2024
            lohns[property][i].book_till = LuxonDateTime.fromFormat(lohns[property][i].book_till, 'yyyyMMdd').toFormat('dd.MM.yyyy');
          }
          lohns[property][i].blocked = lohns[property][i].blocked === '1' || lohns[property][i].blocked === 'J' || lohns[property][i].blocked === 'j' || lohns[property].blocked === 'true';
          lohns[property][i].evaluate = lohns[property][i].evaluate === '1' || lohns[property][i].evaluate === 'J' || lohns[property][i].evaluate === 'j' || lohns[property].evaluate === 'true';
          lohns[property][i].lohn_usage_type = ""+lohns[property][i].unit+lohns[property][i].lohn_usage_type;
          if (lohns[property][i].calculation_type !== '*' && lohns[property][i].calculation_type !== '+' && lohns[property][i].calculation_type !== 'e') {
            lohns[property][i].calculation_type = '+';
          }
          lohns[property][i].dont_send_mobile = lohns[property][i].dont_send_mobile === '1' || lohns[property][i].dont_send_mobile === 'J' || lohns[property][i].dont_send_mobile === 'j' || lohns[property].dont_send_mobile === 'true';
          lohns[property][i].automatic_time_surcharge = lohns[property][i].automatic_time_surcharge === '1' || lohns[property][i].automatic_time_surcharge === 'J' || lohns[property][i].automatic_time_surcharge === 'j' || lohns[property].automatic_time_surcharge === 'true';
          lohns[property][i].weekday_dependant = lohns[property][i].weekday_dependant === '1' || lohns[property][i].weekday_dependant === 'J' || lohns[property][i].weekday_dependant === 'j' || lohns[property].weekday_dependant === 'true';
          lohns[property][i].time_dependant = lohns[property][i].time_dependant === '1' || lohns[property][i].time_dependant === 'J' || lohns[property][i].time_dependant === 'j' || lohns[property].time_dependant === 'true';
          lohns[property][i].special_rules = lohns[property][i].special_rules === '1' || lohns[property][i].special_rules === 'J' || lohns[property][i].special_rules === 'j' || lohns[property].special_rules === 'true';
          lohns[property][i].before_holiday = lohns[property][i].before_holiday === '1' || lohns[property][i].before_holiday === 'J' || lohns[property][i].before_holiday === 'j' || lohns[property].before_holiday === 'true';
          if (lohns[property][i].on_holiday === 'J' || lohns[property][i].on_holiday === 'j' || lohns[property][i].on_holiday === 'true') {
            lohns[property][i].on_holiday = '1';
          } else if (lohns[property][i].on_holiday === 'N' || lohns[property][i].on_holiday === 'n' || lohns[property][i].on_holiday === 'false' || lohns[property][i].on_holiday === '') {
            lohns[property][i].on_holiday = '0';
          }
          if (lohns[property][i].for_dates === 'J' || lohns[property][i].for_dates === 'j' || lohns[property][i].for_dates === 'true') {
            lohns[property][i].for_dates = '1';
          } else if (lohns[property][i].for_dates === 'N' || lohns[property][i].for_dates === 'n' || lohns[property][i].for_dates === 'false' || lohns[property][i].for_dates === '') {
            lohns[property][i].for_dates = '0';
          }
          lohns[property][i].book_on_holidays = lohns[property][i].book_on_holidays === '1' || lohns[property][i].book_on_holidays === 'J' || lohns[property][i].book_on_holidays === 'j' || lohns[property].book_on_holidays === 'true';
          lohns[property][i].after_holiday = lohns[property][i].after_holiday === '1' || lohns[property][i].after_holiday === 'J' || lohns[property][i].after_holiday === 'j' || lohns[property].after_holiday === 'true';
          lohns[property][i].only_rb = lohns[property][i].only_rb === '1' || lohns[property][i].only_rb === 'J' || lohns[property][i].only_rb === 'j' || lohns[property].only_rb === 'true';

        }
      }
      lohns['ALL'] = lohns['ALL'] ? lohns['ALL'] : [];
      return lohns;
    }

  }

}
</script>

<style scoped>

.t-btn {
  height: 32px !important;
  width: 180px !important;
  max-width: 180px !important;
  min-width: 180px !important;
  margin: auto 12px auto 0px;
}

.t-btn-long {
  height: 32px !important;
  width: 240px !important;
  max-width: 240px !important;
  min-width: 240px !important;
  margin: auto 12px auto 0px;
}

.t-btn-left {
  margin: auto 12px auto auto !important;
}


::v-deep label {
  margin-bottom: initial;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  cursor: pointer;
}

.theme--light.v-label {
  color: black;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

::v-deep .theme--light.v-icon.v-icon.v-icon--disabled {
  color: rgb(84, 84, 84) !important;
}

.hidden {
  visibility: hidden;
}

::v-deep .jexcel_content {
  height: calc(100vh - 55px - 2.55rem - 24px - 48px);
}

::v-deep .jexcel_container {
  height: calc(100vh - 55px - 2.55rem - 15px -48px);
}

</style>

